import api from '@/lib/api';

export const SESSION_KEY = 'veluro_visitor_session';

export const readSession = () => {
  try { return JSON.parse(localStorage.getItem(SESSION_KEY) || 'null'); } catch { return null; }
};
export const writeSession = (data) => {
  try { localStorage.setItem(SESSION_KEY, JSON.stringify(data)); } catch { /* ignore */ }
};
export const clearSession = () => { try { localStorage.removeItem(SESSION_KEY); } catch { /* ignore */ } };

/* Fire-and-forget analytics. Never sends message content or personal data — only event names + small enums. */
export const track = (event, props = {}) => {
  const session_id = readSession()?.session_id || null;
  try {
    api.post('/visitor-assistant/event', { event, session_id, props: { ...props, path: window.location.pathname.slice(0, 64) } }).catch(() => {});
  } catch { /* ignore */ }
};
